import React, {useCallback, useMemo} from 'react';

import {useMyTeamsContext} from './hooks/useMyTeamsContext';
import MyTeamsReportList from './MyTeamsReportList.connect';
import {CoachInformation} from './TeamOrgReport';
import WatchlistReportList from './WatchListReportList.connect';

export default function TeamOrgReportList({
  onPress,
  item,
  downlineCoachIds,
  filtersData,
  reportParams,
  fetchMoreReport,
  resetMyTeamsData,
  count,
  reportMeta,
  coachId,
  lastPaidRank,
  highestAchievedRank,
  coachCurrentRank,
  previousScreenName,
  currentScreenName,
}: any) {
  const {reduxActiveTab} = useMyTeamsContext();
  const updatedItem = useCallback(
    (coach: CoachInformation): CoachInformation => {
      if (coach.isParentCoach) return coach;

      if (coach.level) {
        return {
          ...coach,
          level: {
            ...coach.level,
            level: 1,
          },
        };
      }
      return coach;
    },
    [],
  );

  const normalizedList = useMemo(
    () => (Array.isArray(item) ? item?.map(updatedItem) : []),
    [item, updatedItem],
  );

  return reduxActiveTab === 'watchlist' ? (
    <WatchlistReportList
      onPress={onPress}
      item={item || []}
      downlineCoachIds={downlineCoachIds}
      count={count}
      reportMeta={reportMeta}
      fetchMoreReport={fetchMoreReport}
      coachId={coachId}
      lastPaidRank={lastPaidRank}
      highestAchievedRank={highestAchievedRank}
      coachCurrentRank={coachCurrentRank}
      previousScreenName={previousScreenName}
      currentScreenName={currentScreenName}
    />
  ) : (
    <MyTeamsReportList
      filtersData={filtersData}
      reportParams={reportParams}
      onPress={onPress}
      item={normalizedList}
      downlineCoachIds={downlineCoachIds}
      fetchMoreReport={fetchMoreReport}
      resetMyTeamsData={resetMyTeamsData}
      count={count}
      reportMeta={reportMeta}
      coachId={coachId}
      lastPaidRank={lastPaidRank}
      highestAchievedRank={highestAchievedRank}
      coachCurrentRank={coachCurrentRank}
      previousScreenName={previousScreenName}
      currentScreenName={currentScreenName}
    />
  );
}
